var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"mb-4 ml-2",attrs:{"color":"#eb5424","href":"http://api.coach.getboarded.com/oauth"},on:{"click":_vm.loginAuth0}},[_vm._v(_vm._s(_vm.$t('login.btn3')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }